"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("./client");
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder() {
    }
    QueryBuilder.all = function (type) {
        var t = new type();
        var params = [{
                name: 'pageSize',
                value: 1000
            }];
        return client_1.Client.get(t.resource(), params).catch(function (error) { return console.error(error); });
    };
    QueryBuilder.find = function (type, id) {
        var t = new type();
        return client_1.Client.get(t.resource(), id).catch(function (error) { return console.error(error); });
    };
    QueryBuilder.where = function (type, params) {
        var t = new type();
        return client_1.Client.get(t.resource(), params).catch(function (error) { return console.error(error); });
    };
    return QueryBuilder;
}());
exports.QueryBuilder = QueryBuilder;
//# sourceMappingURL=queryBuilder.js.map